<span class="breadcrumb-text">{{'de.his.portal.breadcrumb'|hisUi}}</span> <p-breadcrumb [model]="items" (onItemClick)="onItemClick($event)"></p-breadcrumb>